import { useEffect } from 'react';
import { useABTestSegments } from '@namespace/ab-test';
import { useGetRecommendedDepositAmount } from '../useGetRecommendedDepositAmount';

const RECOMMENDED_DEPOSIT_SEGMENT_PREFIX = 'recommended-deposit';

export const useRecommendedDepositAmount = () => {
  const { includedVariant } = useABTestSegments(
    RECOMMENDED_DEPOSIT_SEGMENT_PREFIX
  );

  const { getRecommendedDepositAmount } = useGetRecommendedDepositAmount();

  useEffect(() => {
    if (includedVariant) {
      getRecommendedDepositAmount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includedVariant]);
};
